export const getGenericPrefillFallbackValue = (fieldId, selectedRow) => {
  if (!selectedRow) return undefined;

  const propertyOwner = selectedRow.property_owner || {};
  const contractor = selectedRow.contractor || {};
  const propertyData = selectedRow.property_data || {};
  const realEstatePresets = selectedRow.realEstatePresets || {};
  const selectedAddress = realEstatePresets.selectedAddress || {};
  const chunkedAddress = selectedRow.chunked_addresses?.primary_address || {};

  switch (fieldId) {
    // --- Contractor Details ---
    case "fe58f065-4277-4848-8820-dd296d4fccaa": {
      // Contractor Personal Name
      const fullName =
        `${contractor.firstName || ""} ${contractor.lastName || ""}`.trim();
      if (!fullName) return contractor.businessName;
      return fullName
        .split(" ")
        .map((n) => n.charAt(0).toUpperCase() + n.slice(1).toLowerCase())
        .join(" ");
    }

    case "bc0dacf3-03ca-4dde-a33a-2a63d86a1c76": // Contractor Company Name
      return contractor.businessName;

    case "b454bb8c-be64-4948-ba59-842451c52196": // Contractor Phone
      return contractor.mobile || contractor.phone;

    case "44c70798-bbf0-4675-a4fe-d2ceb6630a58": // Contractor Full Address
      return contractor.mainAddress || contractor.address;

    case "46b64e25-a7ca-493b-bcf2-420b874e2800": // Contractor Email
      return contractor.email;

    case "2a89b30b-3611-4354-a299-d14a991e7e1c": // Contractor Primary Contact Name
    case "4e2f125d-efa4-4999-aa82-2170aa89e9e1": // Contractor Signature Name
    case "2cf0fe18-fd8b-4fec-a62b-8e26f992b3d5": {
      // Contractor Signature Print Name
      const contactName =
        `${contractor.firstName || ""} ${contractor.lastName || ""}`.trim();
      if (!contactName) return contractor.businessName;
      return contactName
        .split(" ")
        .map((n) => n.charAt(0).toUpperCase() + n.slice(1).toLowerCase())
        .join(" ");
    }

    case "7c03658b-e0f1-466b-b849-fe9639d3dd54": // Contractor Primary Contact Phone
      return contractor.mobile;

    case "825b4d7f-8d84-43d6-aca7-489b13c8d139": // Contractor Primary Contact Email
      return contractor.email;

    case "39586a3c-58a6-4d16-9c18-f38d0e9cf86a": // Contractor License Number
    case "7f0422e1-e2c8-473c-95d0-6f389e53a104": // Contractor State License
    case "d5286594-e1d8-49f1-b2e2-559b0359c909": // Contractor County License
      return contractor.licenseNumber;

    case "4937394b-8e70-4a93-8b0a-7d4a41dd3342": // Contractor County
      return contractor.mainAddressCounty;

    case "1c6d214d-bc2d-476a-a595-df6e2f63cbd5": // Contractor Zip Code
      return contractor.zip;

    case "77fc2668-bf27-4aca-b9ed-dfacacb2e48a": // Contractor City
      return contractor.city;

    case "a23469a2-a6f8-4644-bc7e-cf66d4c56593": // Contractor State
      return contractor.state;

    case "73994072-5ffe-4bf2-9182-e6ddc5f52b2c": // Contractor Street
      return contractor.address1;

    case "d3d0a81f-daed-4abc-8e1d-39d44668a05c": // Contractor Signature Full Address
      return contractor.mainAddress;

    // --- Owner Details ---
    case "55186a2a-bd41-47d8-b2ff-e154840e05cb": // Owner Name
      return (
        propertyOwner.personalName ||
        propertyOwner.businessName ||
        propertyOwner.name
      );

    case "6a9e9640-986c-468d-8cdb-d845278f092a": // Owner Full Address
      return propertyOwner.address;

    case "7905afa1-3413-4400-850e-a326dcc7e565": // Owner Phone
      return propertyOwner.mobile;

    case "0d27a461-8fca-420e-a91e-26d72cf0cd2e": // Owner Email
      return propertyOwner.email;

    case "2c8f5458-f44c-4715-ad33-c9a718a5009c": // Owner Street
      return propertyOwner.address_parts?.address1;

    case "67c021c8-2e7f-45ca-abc7-59be37fd3105": // Owner City
      return propertyOwner.address_parts?.city;

    case "99ca85b3-ba1d-4ce7-9e69-23f6ce0f9314": // Owner State
      return propertyOwner.address_parts?.state;

    case "c64a67bd-5a23-4d5e-986a-80e1b008e994": // Owner Zip Code
      return propertyOwner.address_parts?.zip_code;

    // --- Property Details ---
    case "c8f429d2-5fdd-4ca1-9b21-514633cc148b": // Property/Project Full Address
      return selectedRow.project_address || chunkedAddress.full_address;

    case "2fa4a310-5f02-4017-85e8-e8d50a8a6a7c": // Property/Project Street Number
      return chunkedAddress.number;

    case "b2d81b07-40eb-44b1-bf5d-77955a68bacc": // Property/Project Street Name
      return chunkedAddress.street;

    case "302006ca-1257-4342-9f5e-3f19506a0e79": // Property/Project Street Type
      return chunkedAddress.short_suffix;

    case "0fe0f1f8-d98f-4705-8ec6-b42a1395614f": // Property/Project Street Direction
      return chunkedAddress.pre_direction;

    case "8a6d5ef6-7595-40bd-ab35-1310667c9c02": // Property/Project Unit
      return chunkedAddress.unit_number;

    case "0f57b951-2459-4e2b-855a-0969f3195646": // Property/Project City
      return chunkedAddress.place_name;

    case "cca8174b-4d3c-4a2b-9ea1-4b368c43e2e8": // Property/Project State
      return chunkedAddress.state_name || "FL";

    case "42d579cd-fd1d-448c-8283-b8eb3ddd0116": // Property/Project Zip
      return chunkedAddress.zip_code;

    case "5a86bb6d-ba11-40c6-a033-d31ff4c47cd8": // Tax Folio/Parcel ID
      return (
        propertyData.parcel_number?.display ||
        propertyData.parcel_number?.cleaned ||
        selectedAddress.parcel_id_display ||
        selectedAddress.parcel_id ||
        selectedAddress.parcel_number
      );

    case "e39e294c-d879-42b5-8a93-1314028b24a5": // Legal Description
      return (
        propertyData.legal_description?.full ||
        selectedRow.documents?.noc?.legalDescription
      );

    // --- General / Misc Details ---
    case "0750477e-f7f9-42e7-a2c8-a3a39a416cd1": // Permit Number
      return selectedRow.permit_number;

    case "3e9d0b68-6531-4eaf-b48e-ef6a699b1cfc": // Project Name
      return selectedRow.project_name || selectedRow.package_name;

    case "e931729c-c6e9-4d3d-a9a2-281014a3efef": // Total Area
      return propertyData.specs?.total_area ?? propertyData.total_area;

    case "0d6664c5-1f31-471f-872f-82cb08a1be24": // Stories
      return propertyData.structural_elements?.stories;

    case "f465dc15-edec-498e-a27d-f331eebc82e7": // Bedrooms
      return propertyData.structural_elements?.bedrooms;

    case "4ecc4b09-a59f-4815-ac85-77f1d300ea52": // Bath
      return propertyData.structural_elements?.bathrooms;

    case "e5944574-3653-474e-b750-f3fcf2cf84a0": // Heated Area SQ
      return (
        propertyData.specs?.total_heated_area ?? propertyData.total_heated_area
      );

    default:
      return undefined;
  }
};
